import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import {
  Button,
  Card,
  Grid,
  Icon,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core';
import { BackdropCircular, Breadcrumb } from 'components';
import {
  getQuoteCustomerDataApi,
  getCustomerPushCartApi
} from 'api';
import { useStyles } from '../styles';
import QuoteListings from '../QuoteItems/QuoteListings/QuoteListings';
import QuotePackagesContainer from '../QuoteItems/QuotePackages/QuotePackagesContainer';


const TabPanel = ({ value, index, children }) => {
  return <div hidden={value !== index}>{children}</div>;
};

const QuoteWorkspace = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { userStoreData: {storeCode} } = useSelector((state: IReduxState) => state.user);
  const isCustomer3 = storeCode === 'customer3';
  const {id} = useParams<{ [id: string]: string }>();

  const isPatientGroupActive = location.pathname.includes('/quoting/group/');

  const [tabValue, setTabValue] = useState('listings');

  const {
    currentQuoteCustomer,
    loadingQuoteCustomers,
    currentMarketingSegment,
    customerPushCart,
    loadingCustomerPushCart
  } = useSelector((state: IReduxState) => state.quote);

  const loading =
    loadingQuoteCustomers ||
    loadingCustomerPushCart;

  useEffect(() => {
    if (!currentQuoteCustomer) {
      getQuoteCustomerDataApi({ dispatch, id });
    }
  }, [currentQuoteCustomer, dispatch, id]);

  useEffect(() => {
    if (!customerPushCart && currentQuoteCustomer?.id && !isPatientGroupActive) {
      getCustomerPushCartApi({
        dispatch,
        customerId: currentQuoteCustomer?.id
      });
    }
  }, [currentQuoteCustomer]);

  useEffect(() => {
    if (!isPatientGroupActive && !customerPushCart?.customer) {
      history.push(`/quoting/profile/${id}`);
    }

    if (isPatientGroupActive && !currentMarketingSegment?.value) {
      history.push(`/quoting/group/${id}`);
    }
  }, []);

  const handleCancel = () => {
    if (isPatientGroupActive) {
      history.push(`/quoting/group/${id}`);
    } else {
      history.push(`/quoting/profile/${id}`);
    }
  };

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Create Quote', path: '/quoting' },
            isPatientGroupActive ?
              { name: 'Marketing Segment Details', path: `/quoting/group/${id}` } :
              { name: `${isCustomer3 ? 'Customer' : 'Patient'} Details`, path: `/quoting/profile/${id}` },
            { name: 'Quote Workspace' }
          ]}
        />
      </div>
      <Card className="mx-10 p-8 root-card">
        <Grid container alignItems="center">
          <Grid item xs={12} sm={3}>
            <Typography variant="h6">
              Quote for&nbsp;
              {isPatientGroupActive
                ? `${currentMarketingSegment?.label}`
                : `${customerPushCart?.customer?.firstname} ${customerPushCart?.customer?.lastname}`
              }
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} container justifyContent="center">
            <Tabs
              value={tabValue}
              onChange={(event, newValue) => setTabValue(newValue)}
              variant="scrollable"
              scrollButtons="auto"
              style={{minHeight: '40px', height: '40px'}}
              classes={{
                indicator: classes.tabIndicator,
                flexContainer: classes.fullWidthTabs,
              }}
            >
              <Tab
                label="Listings"
                value="listings"
                className={
                  tabValue === 'listings' ? classes.activeTab : classes.inactiveTab
                }
              />
              <Tab
                label={<span className="whitespace-no-wrap">Packages</span>}
                value="packages_treatments_plans"
                className={
                  tabValue === 'packages_treatments_plans'
                    ? classes.activeTab
                    : classes.inactiveTab
                }
              />
            </Tabs>
          </Grid>
          {!isPatientGroupActive &&
            <Grid item xs={12} sm={3} container justifyContent="flex-end">
              <Button
                onClick={() => history.push(`/quoting/profile/${id}/quote-workspace/patient-activity`)}
                color="primary"
                size="small"
                className={classes.patientActivityButton}
                startIcon={<Icon>recent_actors</Icon>}
              >
                {isCustomer3 ? 'Customer Activity' : 'Patient Activity'}
              </Button>
            </Grid>
          }
        </Grid>
        <Grid container spacing={2} alignItems="center" className="mt-2">
          <Grid item xs={12}>
            <TabPanel value={tabValue} index="listings">
              <QuoteListings handleCancel={handleCancel} />
            </TabPanel>

            <TabPanel value={tabValue} index="packages_treatments_plans">
              <QuotePackagesContainer handleCancel={handleCancel} />
            </TabPanel>
          </Grid>
        </Grid>
      </Card>
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default QuoteWorkspace;
